import { Insurance } from '@/types/closinglock.types';

export const showPendingInsuranceBadge = (insurance: Insurance) => {
    return insurance === Insurance.INSURANCE_ACTION_REQUIRED;
};
